import {GET_COUNTRYCODE, GET_LOGIN, GET_OTP, POST_LOGOUT} from "resources/actionTypes";

export function getLogin(userLogin,navigate) {
  const data = {
    userLogin:userLogin,
    navigate:navigate
  }
  return {
    type: GET_LOGIN.GET_LOGIN_REQUESTED,
    payload: data,
  };
}

export function getOtp(userOtp,navigate) {
  const data ={
    userOtp:userOtp,
    navigate:navigate
  }
  return {
    type: GET_OTP.GET_OTP_REQUESTED,
    payload: data,
  };
}

export function postLogout() {
  return {
    type: POST_LOGOUT.POST_LOGOUT_REQUESTED,
  };
}

export function getCountryCode() {
  return {
      type: GET_COUNTRYCODE.GET_COUNTRYCODE_REQUESTED
  }
}